import * as React from 'react';
import {Route, Switch, useRouteMatch} from "react-router";
import SearchClients from "./Search";
import AddClient from "./Add";
import ViewClient from "./View";
import AddCharge from "./AddCharge";
import ViewCharge from "./ViewCharge";
import AddPayment from "./AddPayment";
import ViewPayment from "./ViewPayment";
import CompleteDocument from "./CompleteDocument";
import ShareFile from "./Share";


const ManageClients: React.FunctionComponent = () => {
    let {path} = useRouteMatch();
    return (<>
        <Switch>
            <Route exact path={path + "/add"}>
                <AddClient/>
            </Route>
            <Route exact path={path + "/view/:clientId"}>
                <ViewClient/>
            </Route>
            <Route exact path={path + "/share/:clientId"}>
                <ShareFile/>
            </Route>
            <Route exact path={path + "/:clientId/documents/complete/:documentId"}>
                <CompleteDocument/>
            </Route>
            <Route exact path={path + "/:clientId/charges/add"}>
                <AddCharge/>
            </Route>
            <Route exact path={path + "/:clientId/payments/add"}>
                <AddPayment/>
            </Route>
            <Route exact path={path + "/:clientId/payments/view/:paymentId"}>
                <ViewPayment/>
            </Route>
            <Route exact path={path + "/:clientId/charges/view/:chargeId"}>
                <ViewCharge/>
            </Route>
            <Route exact path={path}>
                <SearchClients/>
            </Route>
        </Switch>
    </>);
};

export default ManageClients;